import { Loader2 } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <output className="text-center" aria-live="polite">
        <Loader2
          className="mx-auto size-12 animate-spin text-primary"
          aria-hidden="true"
        />
        <p className="mt-4 text-sm text-muted-foreground">Loading...</p>
      </output>
    </div>
  );
}
